<template>
  <div class="is-clickable is-unselectable py-0 px-0"
    :class="`quote-attachment-background-${$theme.name}`">

    <div class="columns is-gapless is-multiline is-relative">
      <div class="button is-primary is-small px-1 m-0"
        @click="handleIsSelectedChange(!isSelectedComputed)"
        :class="{'is-light': !isSelectedComputed, [`is-light-btn-${$theme.name}`]: !isSelectedComputed}"
        style="position:absolute; top: 0; left: 0; z-index: 1">
        <i class="mdi mdi-check"
          :class="{'has-text-grey-light': !isSelectedComputed}" />
      </div>

      <div class="column is-full is-clipped">
        <figure class="image is-3by4 is-fullwidth is-vcentered"
          @click="handleAttachmentClick">
          <img style="object-fit: cover"
            :src="thumbnailUrl">
        </figure>
        <quote-attachment-viewer-modal :active="modalOpen"
          :attachment="attachment"
          :quote-id="quoteId"
          :quote-attachment-id="quoteAttachmentId"
          :quote-attachment-category-id="quoteAttachmentCategoryId"
          @cancel="modalOpen = false"
          @updated-image="imageUpdated()" />

      </div>
      <div class="column is-full is-size-7 is-clipped columns is-multiline">
        <div class="column is-narrow p-0 m-0">
          <span v-if="isLocked"
            class="icon tooltip"
            data-tooltip="Attached by an integration. View only - it cannot be deleted, moved, edited or copied to another quote.">
            <i class="mdi mdi-lock mdi-18px" />
          </span>
          <i v-else
            class="mdi mdi-drag-vertical mdi-24px" />
        </div>
        <div class="columns is-multiline column is-clipped p-0 m-0">
          <div class="column is-full p-0 m-0"
            style="overflow:hidden;text-overflow: ellipsis; font-weight: bold; white-space: nowrap;"
            :tooltip="attachment.filename"
            :title="attachment.filename + '('+pagesCount+')' ">{{ attachment.filename }}({{ pagesCount }})</div>
          <div class="column is-full p-0 m-0">{{ fileDateTime }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuoteAttachmentViewerModal from './QuoteAttachmentViewerModal.vue'
import { DateTime } from 'luxon'

export default {
  name: 'QuoteAttachment',
  components: { QuoteAttachmentViewerModal },
  props: {
    quoteId: {
      type: String
    },
    quoteAttachmentId: {
      type: String
    },
    quoteAttachmentCategoryId: {
      type: String
    },
    attachment: {
      type: Object
    },
    categories: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      modalOpen: false
    }
  },
  computed: {
    isPdf() {
      return this.attachment && this.attachment.filename && this.attachment.filename.toLowerCase().endsWith('.pdf')
    },
    isLocked() {
      return this.attachment?.isLocked === true
    },
    isSelectedComputed() {
      return this.attachment && this.attachment.isSelected === true
    },
    fileDateTime() {
      let dateTime = this.attachment.createdDate
      if (this.attachment.modifiedDate !== undefined) {
        dateTime = this.attachment.modifiedDate
      }
      return DateTime.fromISO(dateTime).toLocaleString()
    },
    pagesCountText() {
      var postfix = 'Page'
      if (this.pagesCount > 1) {
        postfix += 's'
      }
      return this.pagesCount + ' ' + postfix
    },
    pagesCount() {
      // No more quoteAttachmentDerivatives, fallback to 1
      return 1
    },
    fileSize() {
      var size = this.attachment.fileSize
      var i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024))
      return Math.round(size / Math.pow(1024, i)) + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i]
    },
    thumbnailUrl() {
      if (!this.attachment || !this.attachment.filename) return ''
      const filename = this.attachment.filename.toLowerCase()
      const externalStorageURL = this.attachment.externalStorageURL || ''
      const imageExts = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.tiff', '.svg']
      if (filename.endsWith('.pdf')) {
        return require('@/assets/images/attachment-pdf.png')
      } else if (imageExts.some((ext) => filename.endsWith(ext))) {
        return externalStorageURL || require('@/assets/images/image.png')
      }
      else {
        return require('@/assets/images/attachment-doc.png')
      }
    }
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    handleIsSelectedChange(value) {
      this.$emit('update:attachment', {
        attachment: this.attachment,
        isSelected: value
      })
    },
    imageUpdated() {
      this.$emit('image-uploaded')
    },
    async handleAttachmentClick() {
      if (this.isPdf) {
        // Download the PDF directly
        try {
          const response = await fetch(this.attachment.externalStorageURL)
          const blob = await response.blob()
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = this.attachment.filename
          document.body.appendChild(a)
          a.click()
          setTimeout(() => {
            window.URL.revokeObjectURL(url)
            document.body.removeChild(a)
          }, 100)
        } catch (e) {
          console.error('PDF download failed:', e)
        }
      } else {
        this.modalOpen = true
      }
    }
  }
}
</script>
